/**
 * 历史侧栏遮罩与叠层媒体预览的互斥守卫。
 * 预览打开/刚关闭时禁用历史 backdrop，避免 click 穿透把历史一并关掉。
 */

const BODY_OPEN = 'ipe-nested-media-preview-open';
const BODY_CLOSING = 'ipe-nested-media-preview-closing';
const SUPPRESS_MS = 450;

let suppressBackdropUntil = 0;
let closingTimer = null;
let openCount = 0;

function canTouchBody() {
  return typeof document !== 'undefined' && document.body;
}

export function beginNestedMediaPreview() {
  if (!canTouchBody()) return;
  openCount += 1;
  if (closingTimer != null) {
    window.clearTimeout(closingTimer);
    closingTimer = null;
  }
  document.body.classList.remove(BODY_CLOSING);
  document.body.classList.add(BODY_OPEN);
}

export function endNestedMediaPreview() {
  if (!canTouchBody()) return;
  openCount = Math.max(0, openCount - 1);
  if (openCount > 0) return;

  suppressBackdropUntil = Date.now() + SUPPRESS_MS;
  document.body.classList.remove(BODY_OPEN);
  document.body.classList.add(BODY_CLOSING);
  if (closingTimer != null) window.clearTimeout(closingTimer);
  closingTimer = window.setTimeout(() => {
    closingTimer = null;
    document.body.classList.remove(BODY_CLOSING);
  }, SUPPRESS_MS);
}

/** 预览遮罩即将关闭时调用，加长抑制窗口 */
export function suppressHistoryBackdropClose(ms = SUPPRESS_MS) {
  suppressBackdropUntil = Math.max(suppressBackdropUntil, Date.now() + ms);
  if (!canTouchBody()) return;
  document.body.classList.add(BODY_CLOSING);
  if (closingTimer != null) window.clearTimeout(closingTimer);
  closingTimer = window.setTimeout(() => {
    closingTimer = null;
    if (openCount === 0) {
      document.body.classList.remove(BODY_CLOSING);
    }
  }, ms);
}

export function shouldIgnoreHistoryBackdropClose() {
  if (Date.now() < suppressBackdropUntil) return true;
  if (!canTouchBody()) return false;
  return (
    document.body.classList.contains(BODY_OPEN)
    || document.body.classList.contains(BODY_CLOSING)
    || Boolean(document.querySelector('.funding-image-space-preview-overlay'))
    || Boolean(document.querySelector('[data-ipe-video-preview-overlay="1"]'))
  );
}
